import { render, staticRenderFns } from "./InfoCircle.vue?vue&type=template&id=49b9904e&scoped=true&"
import script from "./InfoCircle.vue?vue&type=script&lang=js&"
export * from "./InfoCircle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49b9904e",
  null
  
)

export default component.exports